import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';
import { useTranslations } from '../utils/translationDictionaries';
import './Footer.css';

const Footer = () => {
  const { user } = useAuth();
  const { language } = useLanguage();
  const { t } = useTranslations(language);
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section footer-logo-section">
            <Link to="/" className="footer-logo">
              <img 
                src="https://firebasestorage.googleapis.com/v0/b/realty-website-764ee.firebasestorage.app/o/web-media%2Farg_logo_nobg.png?alt=media&token=53b347a3-8d9e-4e5a-8a1f-64b7cbc32e69" 
                alt="Alicea Realty Group LLC Logo" 
                className="footer-logo-img"
              />
            </Link>
          </div>

          <div className="footer-section">
            <h3>{t('footer.contact')}</h3>
            <p>
              <strong>{t('footer.email')}:</strong>{' '}
              <a href="mailto:alicearealtygroupllc@gmail.com">alicearealtygroupllc@gmail.com</a>
            </p>
            <p>
              <strong>{t('footer.phone')}:</strong>{' '}
              <a href="tel:+17873421648">(787) 342-1648</a>
            </p>
            <div className="social-media-section">
              <h4>{t('footer.followUs')}</h4>
              <div className="social-media-icons">
                <a 
                  href="https://www.facebook.com/people/Alicea-Realty-Group-LLC/100064427511404/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="social-icon"
                  aria-label="Facebook"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                  </svg>
                </a>
                {/* <a 
                  href="https://twitter.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="social-icon"
                  aria-label="Twitter"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
                  </svg>
                </a>
                <a 
                  href="https://youtube.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="social-icon"
                  aria-label="YouTube"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                  </svg>
                </a> */}
              </div>
            </div>
          </div>

          <div className="footer-section">
            <h3>{t('footer.quickLinks')}</h3>
            <ul className="footer-links">
              <li><Link to="/">{t('footer.home')}</Link></li>
              <li><Link to="/properties/for-sale">{t('footer.forSale')}</Link></li>
              <li><Link to="/properties/for-rent">{t('footer.forRent')}</Link></li>
              <li><Link to="/about">{t('footer.aboutUs')}</Link></li>
              <li><Link to="/contact">{t('footer.contact')}</Link></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="certification-logos">
            <div className="certification-logo">
              <img 
                src="https://firebasestorage.googleapis.com/v0/b/realty-website-764ee.firebasestorage.app/o/web-media%2Fequal-housing-logowhite-1000.png?alt=media&token=d6d1b696-0134-44b2-b53f-aa15b395e2a2" 
                alt="Equal Housing Opportunity"
                className="cert-logo-img"
              />
            </div>
            <div className="certification-logo">
              <img 
                src="https://firebasestorage.googleapis.com/v0/b/realty-website-764ee.firebasestorage.app/o/web-media%2Fnar_membershipmark_white.png?alt=media&token=e9d5b1eb-e7e5-40c3-8b93-19ad50b752f9" 
                alt={t('footer.realtorLogo')}
                className="cert-logo-img"
              />
            </div>
          </div>
          <p>&copy; {currentYear} Alicea Realty Group LLC. {t('footer.allRightsReserved')}.</p>
          <p>
            {t('footer.developedBy')}{' '}
            <a 
              href="https://www.jadstelar.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="developer-link"
            >
              Jahdiel Montero Alicea
            </a>
            {!user && (
              <>
                {' | '}
                <Link to="/login" className="admin-link">
                  {t('footer.adminAccess')}
                </Link>
              </>
            )}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
